
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/manual.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Manual","toc":"menu","filename":"docs/x-sdk/demos/x-request/manual.md","lastUpdated":1765981586000,"description":"手动触发请求模式，支持流式响应和主动终止。"};